import { supabase, TABLES } from "../lib/supabase";

export interface ContractCompany {
  id: number;
  company: string;
  active: boolean; // Note: This matches the typo in the database schema
  color_code: string;
  color_code2: string;
}

export interface CreateCompanyData {
  company: string;
  active: boolean;
  color_code: string;
  color_code2: string;
}

export interface UpdateCompanyData {
  company?: string;
  active?: boolean;
  color_code?: string;
  color_code2?: string;
}

export async function getContractCompanies(): Promise<ContractCompany[]> {
  const { data, error } = await supabase
    .from(TABLES.CONTRACT_COMPANIES)
    .select("*")
    .eq("active", true)
    .order("company");

  if (error) {
    console.error("Error fetching contract companies:", error);
    return [];
  }

  return data || [];
}

export async function createCompany(
  data: CreateCompanyData
): Promise<{ success: boolean; error?: string }> {
  try {
    const { error } = await supabase
      .from(TABLES.CONTRACT_COMPANIES)
      .insert([data]);

    if (error) throw error;

    return { success: true };
  } catch (error) {
    console.error("Error creating company:", error);
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error occurred",
    };
  }
}

export async function updateCompany(
  id: number,
  data: UpdateCompanyData
): Promise<{ success: boolean; error?: string }> {
  try {
    const { error } = await supabase
      .from(TABLES.CONTRACT_COMPANIES)
      .update(data)
      .eq("id", id);

    if (error) throw error;

    return { success: true };
  } catch (error) {
    console.error("Error updating company:", error);
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error occurred",
    };
  }
}

export async function deleteCompany(
  id: number
): Promise<{ success: boolean; error?: string }> {
  try {
    const { error } = await supabase
      .from(TABLES.CONTRACT_COMPANIES)
      .delete()
      .eq("id", id);

    if (error) throw error;

    return { success: true };
  } catch (error) {
    console.error("Error deleting company:", error);
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error occurred",
    };
  }
}
